module.exports = __webpack_public_path__ + "img/28_7.835126ab.png";